import { IconButton } from 'lib/@mui';
import { Delete, Edit } from 'lib/@mui/Icons';
import React from 'react';

import styles from './VirtualDeviceItem.module.scss';

export const VirtualDeviceActions = ({ handleOpenConfirmationModal, handleEdit }) => (
    <span className={styles.virtualDeviceActions}>
        <IconButton onClick={handleOpenConfirmationModal}>
            <Delete fontSize="large" color="primary" />
        </IconButton>
        <IconButton className="disabled" onClick={handleEdit}>
            <Edit fontSize="large" color="primary" />
        </IconButton>
    </span>
);
